import $ from 'jquery'

$(document).ready(function() {
  co_vc_downloads()
})

function co_vc_downloads() {
  $('.co_vc_downloads').each(function() {})
}
